import React, { useState, useEffect } from "react"
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api"
import markerImg from "../../assets/images/marker.svg"

const MapContainer = (data) => {
	const mapApiKey = "AIzaSyBPoKL6o69cqp7Zyn2qH9kkOa93xtqO1zw"
	const mapContainerStyle = { width: "100%", height: "500px" }
	const zoomSize = 17
	const [center, setCenter] = useState({ lat: 40.778653, lng: -73.967904 })
	const [fixedMarkerPosition, setFixedMarkerPosition] = useState({ lat: 40.778653, lng: -73.967904 })
	const customMapStyles = [
		/*{
			featureType: "water",
			elementType: "geometry",
			stylers: [
				{
					color: "#2196F3"
				},
				{
					lightness: 17
				}
			]
		},
		{
			featureType: "landscape",
			elementType: "geometry",
			stylers: [
				{
					color: "#2196F3"
				},
				{
					lightness: 20
				}
			]
		},
		{
			featureType: "road.highway",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#FFFFFF"
				},
				{
					lightness: 17
				}
			]
		},
		{
			featureType: "road.highway",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#FFFFFF"
				},
				{
					lightness: 29
				},
				{
					weight: 0.2
				}
			]
		},
		{
			featureType: "road.arterial",
			elementType: "geometry",
			stylers: [
				{
					color: "#FFFFFF"
				},
				{
					lightness: 18
				}
			]
		},
		{
			featureType: "road.local",
			elementType: "geometry",
			stylers: [
				{
					color: "#FFFFFF"
				},
				{
					lightness: 16
				}
			]
		},
		{
			featureType: "poi",
			elementType: "geometry",
			stylers: [
				{
					color: "#F5F5F5"
				},
				{
					lightness: 21
				}
			]
		},
		{
			featureType: "poi.park",
			elementType: "geometry",
			stylers: [
				{
					color: "#DEDEDE"
				},
				{
					lightness: 21
				}
			]
		},
		{
			elementType: "labels.text.stroke",
			stylers: [
				{
					"visibility": "on"
				},
				{
					color: "#FFFFFF"
				},
				{
					lightness: 16
				}
			]
		},
		{
			elementType: "labels.text.fill",
			stylers: [
				{
					"saturation": 36
				},
				{
					color: "#333333"
				},
				{
					lightness: 40
				}
			]
		},*/
		{
			elementType: "labels.icon",
			stylers: [
				{
					"visibility": "off"
				}
			]
		},
		/*{
			featureType: "transit",
			elementType: "geometry",
			stylers: [
				{
					color: "#F2F2F2"
				},
				{
					lightness: 19
				}
			]
		},
		{
			featureType: "administrative",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#FEFEFE"
				},
				{
					lightness: 20
				}
			]
		},
		{
			featureType: "administrative",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#FEFEFE"
				},
				{
					lightness: 17
				},
				{
					weight: 1.2
				}
			]
		}*/
	]
	const customMapOptions = {
		disableDefaultUI: false,
		zoomControl: false,
		streetViewControl: false,
		scaleControl: false,
		fullscreenControl: false,
		mapTypeControl: false,
	}

	const handleMapLoad = (map) => {
		// Map loaded
	}
	const handleCenterButtonClick = () => {
		setCenter({ lat: parseFloat(data?.data?.lat), lng: parseFloat(data?.data?.lng) });
	}

	useEffect(() => {
		if (data!==null && data?.data?.lat && data?.data?.lng) {

			const lat = parseFloat(data.data.lat)
			const lng = parseFloat(data.data.lng)
			console.log("MapContainer received data:", data)  // Debug log for received data
			console.log("Received coordinates:", { lat, lng })  // Debug log for received coordinates
			// Only update if valid coordinates (not 0,0)
			if (!isNaN(lat) && !isNaN(lng) && !(lat === 0 && lng === 0)) {
				setCenter({ lat, lng })
				setFixedMarkerPosition({ lat, lng })
			}
		}
	}, [data])

	return (
		<LoadScript googleMapsApiKey={mapApiKey}>
			<GoogleMap
				mapContainerStyle={mapContainerStyle}
				center={center}
				zoom={zoomSize}
				options={{
					styles: customMapStyles,
					...customMapOptions
				}}
				onLoad={handleMapLoad}
			>
				<MarkerF position={fixedMarkerPosition} icon={markerImg} />
			</GoogleMap>
			<button
				onClick={handleCenterButtonClick}
				style={{display: "none", position: "absolute", cursor: "pointer", top: "8px", right: "25px"}}
			>
				Center
			</button>
		</LoadScript>
	)
}

export default MapContainer